import React from 'react';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import { VseClassEditGrid } from './VseClassEditGrid';
import { VseClassEditTemplate, VseClassComponentEditTemplate, VseClassComponentScheduleEditTemplate } from '../types/VseClassEditTemplate';
import {
  TeachingModeEntity,
  TimeZoneEntity,
} from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    marginBottom: theme.spacing(1),
  },
}));

export type ClassErrorKeyResolver = (index: number, key: keyof VseClassEditTemplate) => string;

export type ClassComponentErrorKeyResolver = (index: number, componentIndex: number, key: keyof VseClassComponentEditTemplate) => string;

export type ClassComponentScheduleErrorKeyResolver = (index: number, componentIndex: number, scheduleIndex: number, key: keyof VseClassComponentScheduleEditTemplate) => string;

export interface VseClassEditListProps {
  list: Array<VseClassEditTemplate>,
  teachingModeOptions: TeachingModeEntity[],
  timeZoneOptions: TimeZoneEntity[],
  onChange: (index: number, changes: Partial<VseClassEditTemplate>) => void,
  onAdd: () => void,
  onDelete: (index: number) => void,
  onComponentChange: (classIndex: number, compIndex: number, changes: Partial<VseClassComponentEditTemplate>) => void,
  onComponentAdd: (classIndex: number) => void,
  onComponentDelete: (classIndex: number, compIndex: number) => void,
  onScheduleChange: (classIndex: number, compIndex: number, schdIndex: number, changes: Partial<VseClassComponentScheduleEditTemplate>) => void,
  onScheduleAdd: (classIndex: number, compIndex: number) => void,
  onScheduleDelete: (classIndex: number, compIndex: number, schdIndex: number) => void,
  resolveClassErrorKey: ClassErrorKeyResolver,
  resolveClassComponentErrorKey: ClassComponentErrorKeyResolver,
  resolveClassComponentScheduleErrorKey: ClassComponentScheduleErrorKeyResolver,
  valProblemKeys?: Array<string>,
}

export function VseClassEditList(props: VseClassEditListProps) {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <React.Fragment>
      {props.list.map((value, index) =>
        <Card
          className={classes.card}
          key={index}
        >
          <VseClassEditGrid
            data={value}
            teachingModeOptions={props.teachingModeOptions}
            timeZoneOptions={props.timeZoneOptions}
            onChange={(changes) => props.onChange(index, changes)}
            onAdd={() => props.onAdd()}
            onDelete={() => props.onDelete(index)}
            onComponentChange={(compIndex, changes) => props.onComponentChange(index, compIndex, changes)}
            onComponentAdd={() => props.onComponentAdd(index)}
            onComponentDelete={(compIndex) => props.onComponentDelete(index, compIndex)}
            onScheduleChange={(compIndex, schdIndex, changes) => props.onScheduleChange(index, compIndex, schdIndex, changes)}
            onScheduleAdd={(compIndex) => props.onScheduleAdd(index, compIndex)}
            onScheduleDelete={(compIndex, schdIndex) => props.onScheduleDelete(index, compIndex, schdIndex)}
            last={props.list.length === (index + 1)}
            resolveClassErrorKey={(key) => props.resolveClassErrorKey(index, key)}
            resolveComponentErrorKey={(componentIndex, key) => props.resolveClassComponentErrorKey(index, componentIndex, key)}
            resolveComponentScheduleErrorKey={(componentIndex, scheduleIndex, key) => props.resolveClassComponentScheduleErrorKey(index, componentIndex, scheduleIndex, key)}
            valProblemKeys={props.valProblemKeys}
          />
        </Card>
      )}
    </React.Fragment>
  );
}
